import api from './apiClient';
import {
  EmailConfig,
  EmailConfigUpdate,
  EmailSettings,
  EmailSettingsUpdate,
} from '../types';

export const emailService = {
  getEmailConfigs: async (): Promise<EmailConfig[]> => {
    const response = await api.get('/emails/configs');
    return response.data;
  },

  getEmailConfig: async (emailType: string): Promise<EmailConfig> => {
    const response = await api.get(`/emails/configs/${emailType}`);
    return response.data;
  },

  updateEmailConfig: async (
    emailType: string,
    data: EmailConfigUpdate
  ): Promise<EmailConfig> => {
    const response = await api.put(`/emails/configs/${emailType}`, data);
    return response.data;
  },

  sendTestEmail: async (emailType: string, testEmail: string): Promise<{ message: string }> => {
    const response = await api.post(`/emails/test/${emailType}?test_email=${encodeURIComponent(testEmail)}`);
    return response.data;
  },

  getEmailSettings: async (): Promise<EmailSettings> => {
    const response = await api.get('/emails/settings');
    return response.data;
  },

  updateEmailSettings: async (
    data: EmailSettingsUpdate
  ): Promise<EmailSettings> => {
    const response = await api.put('/emails/settings', data);
    return response.data;
  },
};








